import {
  createLocation,
  distanceTo,
  getBoundingBox,
  toLatLon,
} from 'geolocation-utils';
import { toSearchViewport } from '../../../provider/location';

const radiusThreshold = 50; // 50km

// TODO:(tomo@) This logic is duplicated on search-service,
//              we should really abstract both into a single
//              place that is then shared.
const getBiggerBoundingBox = (northEastLocation, southWestLocation) => {
  const distanceBetween = distanceTo(northEastLocation, southWestLocation);

  const boundingBoxRadius = distanceBetween / 2;
  const marginRadiusMeters = (radiusThreshold * 1000) / 2;

  /**
   * If the bounding box is roughly larger than the radius threshold,
   * add another margin equal to half the distance (rough radius) between the bounding box points.
   */
  const margin = Math.max(boundingBoxRadius, marginRadiusMeters);

  const boundingBox = getBoundingBox(
    [northEastLocation, southWestLocation],
    margin,
  );

  const { topLeft, bottomRight } = boundingBox;
  const topLeftLocation = toLatLon(topLeft);
  const bottomRightLocation = toLatLon(bottomRight);
  const {
    lat: viewportNorthEastLat,
    lon: viewportSouthWestLong,
  } = topLeftLocation;

  const {
    lat: viewportSouthWestLat,
    lon: viewportNorthEastLong,
  } = bottomRightLocation;

  return {
    viewportNorthEastLat,
    viewportNorthEastLong,
    viewportSouthWestLat,
    viewportSouthWestLong,
  };
};

const getNearbyEventsViewport = ({
  viewportNorthEastLat,
  viewportNorthEastLong,
  viewportSouthWestLat,
  viewportSouthWestLong,
}) => {
  const northEastLocation = createLocation(
    viewportNorthEastLat,
    viewportNorthEastLong,
    'LatLon',
  );
  const southWestLocation = createLocation(
    viewportSouthWestLat,
    viewportSouthWestLong,
    'LatLon',
  );
  return getBiggerBoundingBox(northEastLocation, southWestLocation);
};

export const getSeeAllUrl = ({ viewport, point, getLinkWithFilters }) => {
  if (viewport) {
    const extendedViewport = getNearbyEventsViewport(
      toSearchViewport(viewport),
    );
    return getLinkWithFilters(extendedViewport).url;
  }

  if (point) {
    const currentRadius = point.radius;

    if (!currentRadius || currentRadius < radiusThreshold) {
      return radiusThreshold; // set radius to threshold if search is less.
    }

    // Double Radius if search original radius is above threshold
    const newRadius = 2 * currentRadius;
    return getLinkWithFilters({ ...point, radius: newRadius }).url;
  }

  return null;
};
